export const MONTHS = [
  'Janeiro','Fevereiro','Março','Abril','Maio','Junho',
  'Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'
];

export const MONTHS_SHORT = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];

export function formatCurrency(value) {
  if (value == null || isNaN(value)) return 'R$ 0,00';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
}

export function formatNumber(value) {
  if (value == null || isNaN(value)) return '0';
  return new Intl.NumberFormat('pt-BR').format(value);
}

export function formatPercent(value) {
  if (value == null || isNaN(value)) return '0%';
  return `${Math.round(value)}%`;
}

export function formatMonth(year, month) {
  return `${MONTHS[month - 1]}/${year}`;
}

export function formatMonthShort(year, month) {
  return `${MONTHS_SHORT[month - 1]}/${String(year).slice(2)}`;
}

export function calcGrowth(current, previous) {
  if (!previous || previous === 0) return null;
  return ((current - previous) / previous) * 100;
}

export function getMonthOptions(yearStart = 2024) {
  const now = new Date();
  const options = [];
  for (let y = yearStart; y <= now.getFullYear() + 1; y++) {
    for (let m = 1; m <= 12; m++) {
      options.push({ value: `${y}-${m}`, label: formatMonth(y, m), year: y, month: m });
    }
  }
  return options;
}

export function genPerfId(professionalId, year, month) {
  return `perf-${professionalId}-${year}-${month}`;
}

export function getInitials(name) {
  if (!name) return '?';
  return name.split(' ').slice(0, 2).map(n => n[0]).join('').toUpperCase();
}

export function formatJourney(hireDate) {
  if (!hireDate) return null;
  const tz = 'America/Sao_Paulo';
  const now = new Date(new Date().toLocaleString('en-US', { timeZone: tz }));
  const start = new Date(hireDate + 'T00:00:00');
  let years = now.getFullYear() - start.getFullYear();
  let months = now.getMonth() - start.getMonth();
  if (now.getDate() < start.getDate()) months--;
  if (months < 0) { years--; months += 12; }
  const parts = [];
  if (years > 0) parts.push(`${years} ${years === 1 ? 'ano' : 'anos'}`);
  if (months > 0) parts.push(`${months} ${months === 1 ? 'mês' : 'meses'}`);
  if (parts.length === 0) parts.push('Menos de 1 mês');
  return parts.join(' e ');
}

export function getLast12Months(month, year) {
  return getLastNMonths(month, year, 12);
}

export function getLastNMonths(month, year, n) {
  const months = [];
  for (let i = n - 1; i >= 0; i--) {
    let m = month - i;
    let y = year;
    while (m <= 0) { m += 12; y--; }
    months.push({ m, y });
  }
  return months;
}

export function genUnitPerfId(unitId, year, month) {
  return `uperf-${unitId}-${year}-${month}`;
}

export function avatarColor(name) {
  const colors = ['#41659E','#33528A','#29426F','#6688BA','#1F3355'];
  let hash = 0;
  for (let i = 0; i < (name || '').length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return colors[Math.abs(hash) % colors.length];
}
